<template>
    <div>
        <div>
            <div class="d-flex">
                <h5 style="font-weight: bold">TỔNG QUAN THAY ĐỔI</h5>
                <span :class="getOverviewAttitude(commentDetail.overview)?.class"
                      class="text-white rounded ml-4 p-2">
                    {{ getOverviewAttitude(commentDetail.overview)?.label }}
                </span>
                <span class="rounded p-2" style="font-size: 13px" v-if="lesson == 18">
                    <span  class="p-1 rounded mr-2" :class="getLearningAbility(commentDetail.overview, commentLessonOld.overview, 0)?.class">
                        <i v-if="getLearningAbility(commentDetail.overview, commentLessonOld.overview, 0)?.typeAttitude == 1" class="el-icon-arrow-up text-white"></i>
                        <i v-else-if="getLearningAbility(commentDetail.overview, commentLessonOld.overview, 0)?.typeAttitude == 2" class="el-icon-cpu text-white"></i>
                        <i v-else class="el-icon-arrow-down text-white"></i>
                    </span>
                   {{getLearningAbility(commentDetail.overview, commentLessonOld.overview, 0)?.change}}
                </span>
            </div>
            <div class="pl-4 mt-4">
                <div>
                    <p>Điểm nhấn tiến bộ:</p>
                    <em class="fst-italic text-muted">" {{commentDetail.progress}} "</em>
                </div>
                <div>
                    <p>Vấn đề tồn đọng:</p>
                    <em class="fst-italic text-muted">" {{commentDetail.problem}} "</em>
                </div>
                <div>
                    <p>Đánh giá hiệu quả phương án giai đoạn trước:</p>
                    <em class="fst-italic text-muted">" {{commentDetail.effective}} "</em>
                </div>
            </div>
        </div>
        <div class="d-flex mt-4">
            <h5 style="font-weight: bold">THÁI ĐỘ HỌC TẬP</h5>
            <span :class="getLearningAttitude(commentDetail.learning_attitude)?.class"
                  class="text-white rounded ml-4 p-2">
                {{ getLearningAttitude(commentDetail.learning_attitude)?.label }}
            </span>
            <span class="rounded p-2" style="font-size: 13px" v-if="commentLessonOld.learning_attitude">
                <span  class="p-1 rounded mr-2" :class="getLearningAbility(commentDetail.learning_attitude, commentLessonOld.learning_attitude, 0)?.class">
                    <i v-if="getLearningAbility(commentDetail.learning_attitude, commentLessonOld.learning_attitude, 0)?.typeAttitude == 1" class="el-icon-arrow-up text-white"></i>
                    <i v-else-if="getLearningAbility(commentDetail.learning_attitude, commentLessonOld.learning_attitude, 0)?.typeAttitude == 2" class="el-icon-cpu text-white"></i>
                    <i v-else class="el-icon-arrow-down text-white"></i>
                </span>
               {{getLearningAbility(commentDetail.learning_attitude, commentLessonOld.learning_attitude, 0)?.change}}
            </span>
        </div>
        <div class="mt-2" v-for="(item, index) in commentDetail.automatic_comments" :key="index">{{ item }}</div>
        <div>
            <p class="mr-4">Lời nhắc nhở của giảng viên:</p>
            <em class="fst-italic text-muted">" {{commentDetail.comment_phase}} "</em>

        </div>
        <div class=" mt-4">
            <h5 style="font-weight: bold">NĂNG LỰC HỌC TẬP</h5>
            <div class="col-md-12 row">
                <div class="" style="width: 293px" v-for="(item, index) in commentDetail.learning_ability" >
                    <div class="d-flex align-items-center pb-2">
                        <strong class="mr-4" style="font-size: 13px">{{defineLearningAbility(item, index).label }}:</strong>
                        <span class="rounded p-2 text-white" style="font-size: 13px" :class="defineLearningAbility(item, index)?.class">{{defineLearningAbility(item, index).value }}</span>
                        <span class="rounded p-2" style="font-size: 13px" v-if="getLearningAbility(item, '', index)?.changeAttitude">
                            <span  class="p-1 rounded mr-2" :class="getLearningAbility(item, '', index)?.class">
                                <i v-if="getLearningAbility(item, '', index)?.typeAttitude == 1" class="el-icon-arrow-up text-white"></i>
                                <i v-else-if="getLearningAbility(item, '', index)?.typeAttitude == 2" class="el-icon-cpu text-white"></i>
                                <i v-else class="el-icon-arrow-down text-white"></i>
                            </span>
                           {{getLearningAbility(item, '', index)?.change}}
                        </span>
                    </div>
                </div>
            </div>
            <div class="pl-4 mt-4">
                <div>
                    <p>Phương án của giảng viên</p>
                    <em class="fst-italic text-muted">" {{commentDetail.student_support_plan}} "</em>
                </div>
            </div>
        </div>
        <div class="mt-4">
            <h5 style="font-weight: bold">Giảng viên dự đoán khả năng đạt đầu ra</h5>
            <span class="text-white" :class="commentDetail.output_achievability == 1 ? `badge bg-success` : (commentDetail.output_achievability == 2 ? `badge bg-warning` : `badge bg-danger`)">
                {{ability_achieve_output[commentDetail.output_achievability - 1]}}
            </span>
        </div>
    </div>
</template>

<script>
export default {
    name: "ModalDetailLessonMidOrLast",
    props: {
        commentDetail: {
            type: Object,
            default: () => {
                return {}
            }
        },
        commentLessonOld: {
            type: Object,
            default: () => {
                return {}
            }
        },
        lesson: {
            type: Number,
            default: () => {
                return 0
            }
        }
    },
    data()
    {
        return {
            learning_attitude: [
                {
                    id: 1,
                    label: 'Rất tích cực',
                    class: 'bg-success'
                },
                {
                    id: 2,
                    label: 'Chủ động',
                    class: 'bg-primary'

                },
                {
                    id: 3,
                    label: 'Ổn định',
                    class: 'bg-secondary'

                },
                {
                    id: 4,
                    label: 'Thụ động',
                    class: 'bg-warning'

                },
                {
                    id: 5,
                    label: 'Rất tiêu cực',
                    class: 'bg-danger'

                },
            ],
            evaluate_detail: [

                {
                    label: "Tốt",
                    value: 1,
                    class: 'badge bg-success',
                },
                {
                    label: "Khá",
                    value: 2,
                    class: 'badge bg-warning',
                },
                {
                    label: "Trung bình",
                    value: 3,
                    class: 'badge bg-secondary',
                },
                {
                    label: "Yếu",
                    value: 4,
                    class: 'badge bg-danger',
                }
            ],
            learningAbility: [
                {
                    label: "Listening",
                    value: 'listening',
                },
                {
                    label: "Speaking",
                    value: 'speaking',

                },
                {
                    label: "Reading",
                    value: 'reading',

                },
                {
                    label: "Writing",
                    value: 'writing',
                    class: 'badge bg-warning text-dark',

                },
                {
                    label: "Vocabulary",
                    value: 'vocabulary',
                },
            ],
            ability_achieve_output: ['Khả năng đạt đầu ra cao', 'Chưa rõ ràng', 'Nguy cơ Fail khóa'],
            overview: [
                { label: "Có tiến bộ", id: 1, class: "bg-success"},
                { label: "Không thay đổi", id: 2, class: "bg-primary" },
                { label: "Giảm sút", id: 3, class: "bg-danger" },
            ]
        }
    },
    mounted() {

    },
    methods: {
        getLearningAttitude(id)
        {
            return this.learning_attitude.find(item => item.id === id)
        },
        getOverviewAttitude(id)
        {
            return this.learning_attitude.find(item => item.id === id)
        },
        defineLearningAbility(id, index)
        {
            return {
                'label': this.learningAbility.find(item => item.value === index).label,
                'class': this.evaluate_detail.find(item => item.value === id).class,
                'value': this.evaluate_detail.find(item => item.value === id).label
            }
        },
        getLearningAbility(valueNew, valueOld, index = null)
        {
            if (!valueOld && this.commentLessonOld.learning_ability) {
                valueOld = this.commentLessonOld.learning_ability[index];
            }

            let change = 'Tiến bộ';
            let typeAttitude = 1;
            let className = 'badge bg-success';
            this.typeAttitude = 1;
            if (valueNew == valueOld)
            {
                change = 'Không thay đổi';
                className = 'badge bg-warning';
                typeAttitude = 2;

            } else if (valueNew > valueOld)
            {
                typeAttitude = 3;
                change = 'Giảm sút';
                className = 'bg-danger';
            }

            return {
                'typeAttitude': typeAttitude,
                'class': className,
                'change': change,
                'changeAttitude': valueOld ? change + ' (Giai đoạn trước: ' + this.learning_attitude.find(item => item.id == valueOld).label + ')' : ''
            }
        },
    }
}
</script>

<style scoped>
.bg-success {
    background-color: #0C9200 !important;
}
</style>